import { Button, Col, Form, Icon, Input, message, Row, Upload } from 'antd'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import CustomTable from '../../../elements/Table/CustomTable'
import { get, isEmpty, pick } from 'lodash'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import { handleErrors } from '../../../modules/Utils'
import omitEmpty from 'omit-empty'
import React, { Fragment, useState } from 'react'

function Files(props) {
  const { getFieldDecorator } = props.form

  const activities = get(props.enquiry, '_id')
  const url = `https://files.mondiale.com/api/${activities}/files`
  const { data: filesList, fetching, fetchURL } = useFetchURL(
    url,
    [activities],
    isEmpty(activities),
    undefined,
    false,
  )

  const [fileList, setFileList] = useState([])
  const [updating, setUpdating] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const formData = new FormData()
        fileList.forEach(file => {
          formData.append('upload', file)
        })
        const data = {
          meta: JSON.stringify(
            omitEmpty({
              title: values.title,
              mac: pick(props.enquiry, ['_id', '_key', 'code']),
            }),
          ),
        }
        for (let name in data) {
          formData.append(name, data[name])
        }
        setUpdating(true)
        try {
          let results = await fetch(`https://files.mondiale.com/api/files`, {
            method: 'POST',
            body: formData,
          }).then(handleErrors)
          results && message.success('Uploaded!')
          fetchURL()
        } catch (error) {
          console.error(error)
          message.error(error.errorMessage)
        }
        setUpdating(false)
      }
    })
  }

  const uploadProps = {
    onRemove: file => {
      setFileList([])
    },
    beforeUpload: file => {
      setFileList([file])
      return false
    },
    fileList: fileList,
  }

  async function removeFile(id) {
    const newFolderData = {
      _id: id,
    }

    try {
      await fetch(`https://files.mondiale.com/api/files`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
        body: JSON.stringify(newFolderData),
      })
      setUpdating(false)
      fetchURL()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || "Can't Remove Folder !")
    }
  }

  return (
    <Fragment>
      <Form layout="vertical">
        <Row>
          <Col span={8}>
            <Form.Item>
              <Upload {...uploadProps} multiple={false}>
                <Button>
                  <Icon type="upload" />
                  Select Files
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label="Title">
              {getFieldDecorator('title', {
                rules: [
                  {
                    required: true,
                    message: "Title can't be empty ",
                  },
                ],
              })(<Input placeholder="Title" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Button loading={updating} type="primary" onClick={handleSubmit}>
            Upload
          </Button>
        </Row>
      </Form>
      <Row>
        <CustomTable
          data={filesList}
          defaultPageSize={10}
          fetching={fetching}
          fetch={fetchURL}
          columns={[
            { Header: 'Name', accessor: 'name' },
            { Header: 'Size', accessor: 'size' },
            { Header: 'title', accessor: 'title' },
            {
              Header: 'actions',
              accessor: 'action',
              Cell: ({ value, original }) => (
                <Button
                  type={'danger'}
                  style={{ marginLeft: '10px' }}
                  onClick={() => removeFile(original._id)}>
                  Remove
                </Button>
              ),
            },
          ]}
        />
      </Row>
    </Fragment>
  )
}

export default Form.create()(Files)
